<template>
  <v-container fluid>
    <v-sheet
        v-if="loaded"
        class="px-3 pt-3 pb-3">
      <v-row dense>
        <v-col cols="11" style="margin:2em">
          <h4>Resumen de presupuestos {{year}}</h4>
          <budgets-chart :chart-data="chartBudgets" />
        </v-col>
      </v-row>
    </v-sheet>
  </v-container>
</template>

<script>
import BudgetsChart from "@/components/home/budgetsChart";

export default {
  name: "contable",
  data(){
    return{
      firstTrimestre: 0,
      secondTrimestre: 0,
      thirdTrimestre: 0,
      fourthTrimestre: 0,
      invoices: [],
      budgets: [],
      projects:[],
      chartBudgets:[],
      year: 2023,
      loaded:false
    }
  },
  components:{
    BudgetsChart,
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      let url = this.base_url + '/invV2/admin/infohome/'+this.year+'/' + localStorage.token;
      this.axios.get(url).then(response => {
        if (response.data.first != null) this.firstTrimestre = response.data.first;
        if (response.data.second != null) this.secondTrimestre = response.data.second;
        if (response.data.third != null) this.thirdTrimestre = response.data.third;
        if (response.data.fourth != null) this.fourthTrimestre = response.data.fourth;
        this.invoices = response.data.invoices;
        this.budgets = response.data.budgets;
        this.projects = response.data.projects;
        this.chartBudgets = response.data.chartBudgets[0];
        this.loaded = true;
      });
    },
  }
}
</script>

<style scoped>

</style>